import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('politicalAdTargeting',  {
    bindings: {
      formName: '@',
      formId: '@',
      allValues: '<',
      valueSelections: '<',
      readOnly: '<',
      valueMappings: '<'
    },
    template: require("../templates/politicalAdTargeting.html"),
    controllerAs: '$politicalAdTargetingCtrl',
    controller: function() {
      this.allCustomOptions2 = componentHelper.allCustomOptions2();
    }
});
